import React from "react";

import { PageBuilderOpeningHeroVideoFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import HeroVideo from "components/HeroVideo/HeroVideo";
import { isPresent } from "src/utils/checks";

type Props = PageBuilderOpeningHeroVideoFragment;

const PageBuilderOpeningHeroVideo: React.FC<React.PropsWithChildren<Props>> = ({
  video,
  title,
  content,
  ctaButtons
}) => {
  if (!video?.file?.videoId) return null;

  return (
    <React.Fragment>
      <HeroVideo
        videoId={video.file.videoId}
        trackingTitle={video.trackingTitle}
        title={title?.localized}
        content={content?.localized}
        ctaButtons={ctaButtons?.filter(isPresent)}
      />
    </React.Fragment>
  );
};

export default PageBuilderOpeningHeroVideo;

export const fragments = graphql`
  fragment PageBuilderOpeningHeroVideo on SanityOpeningHeroVideo {
    _key
    title {
      localized
    }

    content {
      localized
    }

    video {
      file {
        videoId
        previewImageUrl
        posterImageDownloadUrl
      }
      posterImage {
        ...ImageWithPreview
      }
      trackingTitle
    }

    ctaButtons {
      ...ButtonCTA
    }
  }
`;
